module.exports = __webpack_public_path__ + "img/hidebreakdown_dark.49b9d33c.svg";